// src/pages/funds.toast.ts —— 提币审核通过后的付款方式提示（0038，用户需求 2026-10-15）。审核页与工作台快捷「通过」共用。
// 后端 ReviewResult.auto_pay 按 Console 自动付款额度预告：expected = 到账金额 < 额度。Console 读不到财务机硬上限，
// 自动出款一句注明「以财务机上限为准」；auto_pay 缺省（额度读取失败）时退回通用文案 toastWdPayout。
import type { Dict } from '../../../shared/src/dc';
import { interpolate } from '../../../shared/src/errors';
import { str } from '../domains/types';
import type { ReviewResult } from './funds.types';

export function wdApprovedToast(t: Dict, res: ReviewResult): string {
  const ap = res.auto_pay;
  if (!ap) return str(t, 'toastWdPayout');
  return interpolate(str(t, ap.expected ? 'toastWdAutoPay' : 'toastWdManualPay'), { t: ap.threshold });
}
